import { createReducer } from 'redux-act';
import {
  clearDestination,
  fetchDestination,
  fetchDestinationFailure,
  setDestination,
  clearMerchandise,
  fetchMerchandise,
  fetchMerchandiseFailure,
  setMerchandise,
} from './destinationActions';
import { DESTINATION_STATUS } from 'lib/enums/destination';

const initialState = {
  destination: {
    status: DESTINATION_STATUS.PENDING,
  },
  merchandise: {
    status: DESTINATION_STATUS.PENDING,
  },
};

export const reducer = createReducer(
  {
    [fetchDestination]: (state) => ({
      ...state,
      destination: {
        ...state.destination,
        status: DESTINATION_STATUS.PENDING,
      },
    }),
    [fetchDestinationFailure]: (state, error) => ({
      ...state,
      destination: {
        ...state.destination,
        error,
        status: DESTINATION_STATUS.FAILED,
      },
    }),
    [setDestination]: (state, destination) => ({
      ...state,
      destination: {
        ...destination,
        error: null,
        status: DESTINATION_STATUS.RESOLVED,
      },
    }),
    [clearDestination]: (state) => ({
      ...state,
      destination: initialState.destination,
    }),
    [fetchMerchandise]: (state) => ({
      ...state,
      merchandise: {
        ...state.merchandise,
        status: DESTINATION_STATUS.PENDING,
      },
    }),
    [fetchMerchandiseFailure]: (state, error) => ({
      ...state,
      merchandise: {
        ...state.merchandise,
        status: DESTINATION_STATUS.FAILED,
        error,
      },
    }),
    [setMerchandise]: (state, merchandise) => ({
      ...state,
      merchandise: {
        ...merchandise,
        error: null,
        status: DESTINATION_STATUS.RESOLVED,
      },
    }),
    [clearMerchandise]: (state) => ({
      ...state,
      merchandise: initialState.merchandise,
    }),
  },
  initialState,
);
